import { Descriptions } from 'antd';
import { ISimpleUser } from 'app/containers/User/slice/types';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { formatUserName } from 'utils/helpers';
import { IRecipe } from '../../types';
import RecipeResourceTable from '../RecipeResourceTable/RecipeResourceTable';

interface IProps {
  recipe?: IRecipe | null;
  withResourceTable?: boolean;
  withTitle?: boolean;
  withDescription?: boolean;
  recommendationCreator?: ISimpleUser | null;
}

const RecipeDetails: FC<IProps> = ({
  recipe,
  withResourceTable = true,
  withDescription = true,

  withTitle = false,
  recommendationCreator,
}) => {
  const { t } = useTranslation();

  if (!recipe) {
    return null;
  }

  return (
    <>
      <Descriptions
        bordered
        column={{ lg: 2, md: 1, xs: 1, sm: 1 }}
        labelStyle={{ minWidth: 200 }}
        title={withTitle && t('Recipe.RecipeInformation', 'Recipe information')}
      >
        <Descriptions.Item label={t('Recipe.Title', 'Title')}>
          {recipe.name}
        </Descriptions.Item>
        {recommendationCreator ? (
          <Descriptions.Item
            label={t('Recipe.RecommendationCreator', 'Recommendation creator')}
          >
            {formatUserName(recommendationCreator)}
          </Descriptions.Item>
        ) : (
          <Descriptions.Item label={t('Recipe.Creator', 'Creator')}>
            {formatUserName(recipe.createdBy)}
          </Descriptions.Item>
        )}

        <Descriptions.Item label={t('Recipe.Category', 'Category')} span={2}>
          {recipe.category.name}
        </Descriptions.Item>

        <Descriptions.Item label={t('Common.Culture', 'Culture')}>
          {recipe.culture.name}
        </Descriptions.Item>

        <Descriptions.Item
          span={2}
          label={t('Recipe.RecommendedBBCH', 'Recommended BBCH')}
        >
          {`${recipe.bbchFrom} - ${recipe.bbchTo}`}
        </Descriptions.Item>
        {withDescription && (
          <Descriptions.Item
            contentStyle={{ whiteSpace: 'pre-line' }}
            label={t('Recipe.Description', 'Recipe description')}
          >
            {recipe.description}
          </Descriptions.Item>
        )}
      </Descriptions>
      {withResourceTable && (
        <RecipeResourceTable
          isEditable={false}
          selectedResources={recipe.resources}
        />
      )}
    </>
  );
};

export default RecipeDetails;
